const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? 'https://webservices.jacobyandmeyers.com:8801'
  : '';

export const toApiUrl = (pathSegment: string) => (
  `${API_BASE_URL}/api${ensureLeadingSlash(pathSegment)}`
);

const ensureLeadingSlash = (str: string) => (str[0] === '/' ? str : `/${str}`);
